/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/175-briefcase': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15 4h-4V3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-9-.998L6.002 3h3.996l.002.002V4H6v-.998zM15 8h-2v1.5c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5V8H5v1.5c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5V8H1V7h14v1z"/>'
  }
})
